import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardLayoutService {
  // Mobile sidebar state
  private readonly isMobileSidebarOpen$$ = new BehaviorSubject<boolean>(false);
  readonly isMobileSidebarOpen$ = this.isMobileSidebarOpen$$.asObservable();

  // User menu dropdown state
  private readonly isUserMenuOpen$$ = new BehaviorSubject<boolean>(false);
  readonly isUserMenuOpen$ = this.isUserMenuOpen$$.asObservable();

  toggleMobileSidebar(): void {
    this.isMobileSidebarOpen$$.next(!this.isMobileSidebarOpen$$.value);
  }

  openMobileSidebar(): void {
    this.isMobileSidebarOpen$$.next(true);
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen$$.next(false);
  }

  toggleUserMenu(): void {
    this.isUserMenuOpen$$.next(!this.isUserMenuOpen$$.value);
  }

  openUserMenu(): void {
    this.isUserMenuOpen$$.next(true);
  }

  closeUserMenu(): void {
    this.isUserMenuOpen$$.next(false);
  }
}
